var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_6940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1372 23.9607C15.5481 20.9435 21.0467 13.6309 21.0467 9.52335C21.0467 4.54171 17.005 0.5 12.0234 0.5C7.04171 0.5 3 4.54171 3 9.52335C3 13.6309 8.49861 20.9435 10.9095 23.9607C11.4876 24.6798 12.5591 24.6798 13.1372 23.9607ZM12.0234 6.51557C12.8211 6.51557 13.5861 6.83246 14.1502 7.39653C14.7142 7.9606 15.0311 8.72564 15.0311 9.52335C15.0311 10.3211 14.7142 11.0861 14.1502 11.6502C13.5861 12.2142 12.8211 12.5311 12.0234 12.5311C11.2256 12.5311 10.4606 12.2142 9.89653 11.6502C9.33246 11.0861 9.01557 10.3211 9.01557 9.52335C9.01557 8.72564 9.33246 7.9606 9.89653 7.39653C10.4606 6.83246 11.2256 6.51557 12.0234 6.51557Z",
    fill: "#0F0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_6940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.4114e57d.svg";
export { ForwardRef as ReactComponent };